import firebase from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyARbz4wRAUkywR_ZRvbifGNQLM1iojUD3Q",
  authDomain: "fantasy-finance-f2b3d.firebaseapp.com",
  projectId: "fantasy-finance-f2b3d",
  storageBucket: "fantasy-finance-f2b3d.appspot.com",
  messagingSenderId: "246491978793",
  appId: "1:246491978793:web:5149800ee00fe8558c1038",
  measurementId: "G-XM1C057J8X",
};

firebase.initializeApp(firebaseConfig);
